module.exports = __webpack_public_path__ + "media/images/mindset/content-image2-6554728f118d1a10a849652ad40c1e8f.jpg";